import { Box, Table, TableRow, TopBar } from '@sam/components';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';

import { convertCustomerLocationsIntoOverviewTableEntries } from '../../utils/customerLocation/CustomerLocation.utils';
import { useUser } from '../../components/UserContext';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const CustomerLocationOverview: React.FC = () => {
  const { axios, user, updateContextUser } = useUser();
  const [filterValue, setFilterValue] = useState<string>('');
  const { data: loadedCustomerLocations } = useData('CUSTOMER_LOCATION_ALL', {
    config: { fallbackData: [] },
  });
  const { data: loadedCustomers } = useData('CUSTOMER_ALL_ACTIVE', {
    config: { fallbackData: [] },
  });

  const navigate = useNavigate();
  const { t } = useTranslation();

  //Hook to set tableRows after customers and locations are loaded
  const rows: TableRow[] = useMemo(
    (): TableRow[] =>
      convertCustomerLocationsIntoOverviewTableEntries(
        loadedCustomerLocations,
        navigate,
        loadedCustomers,
      ),
    [loadedCustomerLocations, loadedCustomers, navigate],
  );

  return (
    <>
      <TopBar title={t('pages.customerLocation.overview.topBarHeadline')} onSearch={setFilterValue}>
        <IconComponent type={IconType.ADD} onClick={() => navigate('/customer/location/create')} />
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.CUSTOMER_LOCATION_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.CUSTOMER_LOCATION_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          filterValue={filterValue}
          rows={rows}
          header={
            t('pages.customerLocation.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};
